/**
 * Licenses tab content for License Management page.
 *
 * Extracted from LicenseManagementPage.tsx (Sub-PR 6.3).
 */

import type { License, LicenseCriteria, Organisation, XeroInvoiceState } from '../../types'
import { LicensesFilterBar } from './LicensesFilterBar'
import { LicensesModals } from './LicensesModals'
import { LicensesStatsSummary } from './LicensesStatsSummary'
import { LicensesTable } from './LicensesTable'
import { useLicensesTabState } from './use-licenses-tab-state'

interface LicensesTabProps {
  licenses: License[]
  organisations: Organisation[]
  xeroInvoices: XeroInvoiceState[]
  licenseCriteria: LicenseCriteria[]
  onRefresh: () => Promise<void>
}

export function LicensesTab(props: LicensesTabProps): React.ReactElement {
  const { licenses, organisations, xeroInvoices, licenseCriteria, onRefresh } = props
  const state = useLicensesTabState({ licenses, organisations, onRefresh })
  return (
    <div className="space-y-6">
      <LicensesFilterBar
        filters={state.filters}
        organisations={organisations}
        onCreate={() => {
          state.modals.setShowCreateModal(true)
        }}
      />
      <LicensesTable
        licenses={state.filteredLicenses}
        getOrgName={state.getOrgName}
        onEdit={state.modals.setEditingLicense}
        onExtend={state.modals.setExtendingLicense}
        onActivate={state.modals.setActivatingLicense}
        onSuspend={state.modals.setSuspendingLicense}
      />
      <LicensesStatsSummary licenses={licenses} />
      <LicensesModals
        modals={state.modals}
        actions={state.actions}
        organisations={organisations}
        xeroInvoices={xeroInvoices}
        licenseCriteria={licenseCriteria}
        onRefresh={onRefresh}
      />
    </div>
  )
}
